import {
  breakpointSizes,
  getBreakpointDown,
  getFontCss,
  HoverableLinkSizes,
  styleConstants,
} from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import ExtendLogoFlat from 'src/assets/images/Extend-Logo-Flat.svg'
import ResourceCenterLink from 'src/components/ResourceCenterLink/ResourceCenterLink'
import { SupportedBrands } from 'src/enums'
import Trns, { translateSingleString } from 'src/localization/Trns'
import { selectNullSafeLocaleFromState } from 'src/redux/selectors/auth.selectors'
import { selectBrandName } from 'src/redux/selectors/session.selectors'
import { useWhitelabel } from 'src/utils/whitelabel.utils'
import { css } from 'styled-components'

interface UnauthedFooterProps {
  className?: string
  isSignUp?: boolean
  topMargin?: boolean
}

const UnauthedFooter: React.FC<UnauthedFooterProps> = ({
  isSignUp,
  className,
  topMargin = true,
}) => {
  const { whiteLabelIncludes } = useWhitelabel()
  const isExtendBrand = whiteLabelIncludes(SupportedBrands.Extend)
  const brand = useSelector(selectBrandName)
  const isJPM = brand === SupportedBrands.Jpm
  const locale = useSelector(selectNullSafeLocaleFromState)

  return (
    <footer
      css={css`
        position: relative;
        display: flex;
        align-items: center;
        width: 600px;
        ${topMargin &&
        css`
          margin-top: 40px;
        `}
        justify-content: ${!!isSignUp && !isExtendBrand
          ? `space-between`
          : `center`};
        ${getBreakpointDown(breakpointSizes.XSM)(css`
          width: 100%;
        `)}
      `}
      className={className}
    >
      <p
        css={css`
          ${getFontCss(
            12,
            styleConstants.colors.gray_darkest,
            styleConstants.fontFamilies.regular,
          )};
        `}
      >
        {isExtendBrand && (
          <span dangerouslySetInnerHTML={{ __html: '&#169;' }} />
        )}
        {isExtendBrand && (
          <span
            css={css`
              margin: 0px 2px;
            `}
          >
            <Trns source={'Extend Enterprises'} />
          </span>
        )}
        {isSignUp && !isExtendBrand && !isJPM && (
          <span
            css={css`
              margin: 0px 2px;
            `}
          >
            <Trns
              source={'Want a demo? Reach out via our ${resourceCenter}'}
              expressions={{
                resourceCenter: (
                  <ResourceCenterLink
                    size={HoverableLinkSizes.Small}
                    underline
                    regular
                  />
                ),
              }}
            />
          </span>
        )}
      </p>
      {!isExtendBrand && !isJPM && (
        <p
          css={css`
            ${getFontCss(
              12,
              styleConstants.colors.gray_darkest,
              styleConstants.fontFamilies.regular,
            )};
            position: relative;
            white-space: nowrap;
            width: 128px;
          `}
        >
          <Trns source={'powered by'} />
          <img
            css={css`
              margin-left: 4px;
              height: 10px;
              position: absolute;
              bottom: 3px;
            `}
            src={ExtendLogoFlat}
            alt={translateSingleString(locale, 'Extend')}
          />
        </p>
      )}
    </footer>
  )
}

export default UnauthedFooter
